export default __webpack_public_path__ + "static/1-867a1a0c27a5066686672115fea13c71.webp";